<template>
  <div class="w-full flex flex-col p-1 border-box h-full">
    <div class="h-12 w-full flex flex-none justify-center bg-white py-2 border-box border-t bg-gray-200">
      <pbc-toggle-button v-model='isChooseMode'>
        <h3 class="mx-3 my-1 font-semibold text-sm leading-snug tracking-wide">
          Gallery
        </h3>
      </pbc-toggle-button>
      <pbc-toggle-button v-model='isUploadMode'>
        <h3 class="mx-3 my-1 font-semibold text-sm leading-snug tracking-wide">
          Upload
        </h3>
      </pbc-toggle-button>
    </div>

    <div class="grow overflow-auto">
      <apollo-video-gallery v-if='isChooseMode'
                            class="w-full shadow rounded"
                            :game-id='gameId'
                            @select='$emit("select", $event)'
                            />
      <video-uploader v-if='isUploadMode'
                            class="w-full shadow rounded"
                            :game-id='gameId'
                            @uploaded='onUpload'
                            :already-uploaded='uploadedVideos'
                            @select='$emit("select", $event)'
                            />
    </div>
  </div>
</template>
<script>
import VideoUploader from '@ui/molecules/VideoUploader.vue';
import ApolloVideoGallery from '@ui/organisms/ApolloVideoGallery.vue';

export default {
  props: {
    gameId: {
      type: String,
      default: 'default'
    },
    uploadedVideos: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      mode: 'choose'
    }
  },
  methods: {
    onUpload(video) {
      console.log('upload video', video);
      this.uploadedVideos.push(video);
      this.$emit('uploadedVideos', video);
    }
  },
  components: {
    ApolloVideoGallery,
    VideoUploader,
  },
  computed: {
    isChooseMode: {
      get() {
        return this.mode === "choose";
      },
      set(nv) {
        if (nv) {
          this.mode = "choose";
        }
      }
    },
    isUploadMode: {
      get() {
        return this.mode === "upload";
      },
      set(nv) {
        if (nv) {
          this.mode = "upload";
        }
      }
    }
  }
}
</script>
